module.exports = __webpack_public_path__ + "img/img14,5.3a6ec95f.svg";